import { render } from "./Spacer.vue?vue&type=template&id=5426078e"
import script from "./Spacer.vue?vue&type=script&lang=js"
export * from "./Spacer.vue?vue&type=script&lang=js"
script.render = render

export default script